const MAX_CHARACTERS = 100

export const isEmailValidator = (email: string): [boolean, string] => {
	const re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
	return [!re.test(email), "phronesis.usermanagement.error.noEmail"]
}

const haveValue = (value: string) => {
	return value === null || value === undefined
}

const isValidString = (value: string) => {
	return value.trim() === ""
}

export const isEmptyString = (value: string): [boolean, string] => {
	return [
		haveValue(value) || isValidString(value),
		"phronesis.usermanagement.error.empty",
	]
}

export const max100Characters = (value: string): [boolean, string] => {
	return [
		value.length > MAX_CHARACTERS,
		"phronesis.usermanagement.error.max100",
	]
}

export const atLeastChecked = (value: Array<any>): [boolean, string] => {
	return [value.length <= 0, "phronesis.usermanagement.error.notChecked"]
}
